import { initialize, drs } from '@transmitsecurity/platform-web-sdk'
import { setDrs } from './transmit-client'

export default function initTransmit () {
  const { CxLogoutDrs } = window.__FEATURES__ || {}
  if (!CxLogoutDrs) return // Don't initialize transmit at all if the feature flag is false as we're only using it for DRS

  const { clientId, drsServerPath } = window.__CONFIG__?.transmit ?? {}

  try {
    initialize({
      clientId,
      drs: {
        serverPath: drsServerPath,
        enableSessionToken: true
      }
    })
  } catch (err) {
    if (window.dtrum) {
      window.dtrum.reportError(err)
    }
  }

  setDrs(drs)
  window.__drsReady = Promise.resolve()
}
